import { render } from "./ContactsEntityRegistrationInfo.vue?vue&type=template&id=2746618a"
import script from "./ContactsEntityRegistrationInfo.vue?vue&type=script&lang=js"
export * from "./ContactsEntityRegistrationInfo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__